import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: '¿Es un método de dejar llorar (Cry It Out)?',
  a: 'No. El enfoque de esta guía es completamente respetuoso y compatible con el apego seguro. No se trata de dejar llorar y ya. Se trata de entender las señales de tu bebé, ajustar el entorno y reducir dependencias de manera gradual y amorosa.'
}, {
  q: '¿A partir de qué edad funciona?',
  a: 'La guía cubre desde recién nacidos hasta los 3 años, con estrategias y tablas específicas para cada etapa. Hay un capítulo dedicado a cada rango de edad con señales de sueño particulares y rutinas adaptadas.'
}, {
  q: '¿Cuándo recibo el material?',
  a: 'El acceso es inmediato. Recibirás un correo con el enlace de descarga al instante después de tu compra. Sin esperas. Puedes empezar a leer en los próximos 5 minutos desde cualquier dispositivo.'
}, {
  q: '¿Qué pasa si ya lo intenté todo y nada funcionó?',
  a: "La mayoría de los 'consejos' que circulan en internet son tips sueltos sin contexto. Esta guía es un sistema: primero entiendes el por qué, luego aplicas el qué. Esa es la diferencia. Y si aún así no funciona para ti, tienes 7 días de garantía de devolución."
}, {
  q: '¿Necesito leer las 47 páginas completas?',
  a: 'No. La guía está diseñada para madres cansadas: fácil de escanear, con resúmenes, checklists y acciones inmediatas. Puedes ir directo al capítulo que más necesitas hoy y empezar a aplicar en minutos.'
}, {
  q: '¿Funciona si estoy dando pecho?',
  a: 'Sí. La guía es compatible con lactancia materna y también con biberón. Abordamos específicamente el tema de las asociaciones de sueño relacionadas con la lactancia y cómo manejarlas de forma gradual y respetuosa.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 md:py-24 px-4 md:px-6 bg-navy-light" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <FadeIn data-id="element-129">
          <div className="text-center mb-10 md:mb-16" data-id="element-130">
            <div className="inline-block bg-navy border border-navy-light text-white/70 font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-4 uppercase tracking-wider" data-id="element-131">
              Preguntas frecuentes
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight" data-id="element-132">
              Resolvemos tus
              <br data-id="element-133" />
              <span className="text-gold italic" data-id="element-134">últimas dudas</span>
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-3 md:space-y-4" data-id="element-135">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} direction="up" data-id="element-136">
                <div className="bg-navy-card border border-navy-light rounded-xl overflow-hidden transition-all duration-300 hover:shadow-md hover:border-gold/30" data-id="element-137">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left transition-colors" aria-expanded={isOpen} data-id="element-138">
                    <span className={`font-sans font-semibold text-base md:text-lg pr-4 transition-colors ${isOpen ? 'text-gold' : 'text-white'}`} data-id="element-139">
                      {faq.q}
                    </span>
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-gold text-navy' : 'bg-navy text-white'}`} data-id="element-140">
                      {isOpen ? <MinusIcon className="w-4 h-4" data-id="element-141" /> : <PlusIcon className="w-4 h-4" data-id="element-142" />}
                    </div>
                  </button>
                  <AnimatePresence initial={false} data-id="element-143">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-144">
                        <div className="px-5 md:px-6 pb-6 text-white/70 text-sm md:text-base leading-relaxed" data-id="element-145">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}